import { IRadioGroupOption } from '../RadioGroup.types';

import styles from './RadioGroupOption.module.scss';

const RadioGroupOption = ({ value, active, id, ariaLabel, onSelect }: IRadioGroupOption) => (
  <label className={styles.container}>
    <input
      id={`input_${id}`}
      aria-label={ariaLabel && `input ${ariaLabel}`}
      type="checkbox"
      value={value}
      checked={active}
      onChange={onSelect}
    />
    <span id={`span_${id}`} aria-label={ariaLabel && `span ${ariaLabel}`} className={styles.checkmark} />
  </label>
);

export default RadioGroupOption;
